






























































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import LanguagesDropDown from '@/components/DropDowns/LanguagesDropDown.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

@Component({
    components: {
        LanguagesDropDown,
    },
    computed: {
        ...mapGetters({
            currentEditCategory: 'TicketAttributes/getCurrentEditCategory',
            inquiryRoleUsers: 'TicketAttributes/getInquiryRoleUsers',
            inquiryRoles: 'TicketAttributes/getInquiryRoles',
        }),
    },
})
export default class EditCategory extends Mixins(InputFieldMethods) {
    public languages: any = [];
    public categoryTitles: any = [];
    public currentLanguage = 'en';

    constructor() {
        super();
    }

    public setTranslatableFields(languages: any) {
        languages.forEach((language: any) => {
            this.addTranslation(language);
        });
    }

    public addTranslation(addedLanguage: any) {
        const category     = this.$store.getters['TicketAttributes/getCurrentEditCategory'];
        const checkIfExist = this.categoryTitles.find((title: any) => title.lang === addedLanguage.key);
        const content      = category.translations.find((translation: any) => translation.language_id === addedLanguage.id);

        if (typeof checkIfExist === 'undefined') {
            this.categoryTitles.push({ lang: addedLanguage.key, content: typeof content === 'undefined' ? '' : content.description });
        }
    }

    public removeTranslation(deletedLanguage: any) {
        this.categoryTitles = this.categoryTitles.filter((title: any) => title.lang !== deletedLanguage.key);
    }

    public setCurrentLanguage(selectedLanguage: any) {
        this.currentLanguage = selectedLanguage.key;
    }

    public editInquiryCategory() {
        const category = this.$store.getters['TicketAttributes/getCurrentEditCategory'];

        this.$validator.validate()
            .then((valid) => {
                if (valid) {
                    this.$store.dispatch(Actions.EDIT_INQUIRY_CATEGORY, {
                        editCategoryTitles: this.categoryTitles,
                        editCategoryId: category.id,
                        editRoleAssigne: category.assigned_role_id,
                        editRoleUser: category.assigne_id,
                        typeId: this.$store.getters['TicketAttributes/getCurrentTicketType'],
                        projectId: Number(this.$store.getters['TicketAttributes/getCurrentProject']),
                    });
                }
            });
    }

    public deleteInquiryCategory() {
        this.$store.dispatch(Actions.DELETE_INQUIRY_CATEGORY, {
            projectId: Number(this.$store.getters['TicketAttributes/getCurrentProject']),
            categoryId: this.$store.getters['TicketAttributes/getCurrentEditCategory'].id,
            typeId: this.$store.getters['TicketAttributes/getCurrentTicketType'],
        });
    }

    public setRoleAssignee(ev: any) {
        const category = this.$store.getters['TicketAttributes/getCurrentEditCategory'];
        category.assigne_id = '';
        if (ev.srcElement.value) {
            this.$store.dispatch(Actions.FETCH_INQUIRY_ROLE_ASSIGNEE_USERS, {roleId: ev.srcElement.value, projectId: this.selectedProjectId});
        } else {
            this.$store.commit(Mutations.SET_INQUIRY_ROLE_ASSIGNEE_USERS, []);
        }
    }

    get selectedProjectId() {
        return Number(this.$store.getters['TicketAttributes/getCurrentProject']);
    }

    public cancel() {
        this.$store.commit(Mutations.SET_EDIT_CATEGORY_VISIBILITY, false);
    }

    public created() {
        const category = this.$store.getters['TicketAttributes/getCurrentEditCategory'];
        this.$store.dispatch(Actions.FETCH_INQUIRY_ROLE_ASSIGNEE);

        this.languages = category.translations.map((translation: any) => translation.language_id);

        if (category.assigned_role_id) {
            this.$store.dispatch(Actions.FETCH_INQUIRY_ROLE_ASSIGNEE_USERS, {roleId: category.assigned_role_id, projectId: this.selectedProjectId});
        }
    }
}
